import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

let isHandlingUnauthorized = false;

const isAuthActionEndpoint = (url = '') =>
  ['/auth/login', '/admins/login', '/auth/recovery-pass'].some((path) =>
    url.includes(path)
  );

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestURL = error?.config?.url || '';

    if (status === 401 && !isAuthActionEndpoint(requestURL) && !isHandlingUnauthorized) {
      isHandlingUnauthorized = true;

      localStorage.removeItem('USER_TOKEN');
      localStorage.removeItem('ADMIN_TOKEN');
      localStorage.removeItem('userToken');
      localStorage.removeItem('adminToken');

      const redirectPath = window.location.pathname.startsWith('/admin')
        ? '/admin'
        : '/';

      window.location.replace(redirectPath);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
